import { Account } from '@betty/account/state';
import { BottomSheet, StackNavigationProp } from '@betty/navigation';
import { ButtonState } from './OnboardingHeader.types';

export const getButtonState = (account?: Account) => {
  const { status, statusReason, verificationMeta } = account || {};
  const { autoKycAttemptsLeft = 0, maximumAutoKYCAttempts = 0 } =
    verificationMeta || {};

  if (statusReason === 'KYC Verification Pending') {
    return ButtonState.VERIFYING_ACCOUNT;
  }

  if (statusReason === 'Restricted for Security Review') {
    return ButtonState.PROVIDE_ID;
  }

  if (
    statusReason === 'KYC in progress' ||
    statusReason === 'Manual Verification Required' ||
    statusReason === 'Restricted - KYC in progress' ||
    statusReason === 'Restricted - Manual Verification Required' ||
    statusReason === 'Under Security Review - KYC in progress' ||
    statusReason === 'Under Security Review - Manual Verification Required'
  ) {
    return ButtonState.GET_UPDATE;
  }

  if (
    statusReason === 'Pending Document Verification Review' ||
    statusReason === 'Document Verification Failed'
  ) {
    return ButtonState.VERIFY_ACCOUNT;
  }

  if (
    status === 'Suspended' ||
    statusReason === 'Restricted - Document Verification Failed' ||
    statusReason === 'Under Security Review - Document Verification Failed' ||
    (autoKycAttemptsLeft === 0 && maximumAutoKYCAttempts !== 0)
  ) {
    return ButtonState.CONTACT_SUPPORT;
  }

  if (status === 'Approved' || status === 'Timeout') {
    return ButtonState.DEPOSIT;
  }

  if (
    status === 'Pending' &&
    autoKycAttemptsLeft > 0 &&
    autoKycAttemptsLeft < maximumAutoKYCAttempts
  ) {
    return ButtonState.RETRY_VERIFICATION;
  }

  if (status === 'Pending') {
    return ButtonState.VERIFY_IDENTITY;
  }
};

export const handleVerifyAccount = (
  navigation: StackNavigationProp<AppNavigatorParamsList>,
  account?: Account,
) => {
  const { statusReason } = account || {};

  if (statusReason === 'Pending Document Verification Review') {
    BottomSheet.open({
      namespace: 'common',
      type: 'InfoImage',
      data: {
        titleNS: 'onboarding',
        titleKey: 'pendingVerification',
        descriptionNS: 'onboarding',
        descriptionKey: 'verifyingDocuments',
      },
    });
  }

  if (statusReason === 'Document Verification Failed') {
    navigation.navigate('UploadDocumentsScreen');
  }
};

export const handleVerifyIdentity = (
  navigation: StackNavigationProp<AppNavigatorParamsList>,
  account?: Account,
) => {
  const { statusReason } = account || {};

  if (statusReason === 'KYC Address Mismatch') {
    navigation.navigate('AddressVerificationScreen');

    return;
  }

  BottomSheet.open({
    namespace: 'onboarding',
    type: 'OnfidoEntry',
  });
};
